import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { imgUrl } from "@/lib/api";
import { MapPin, Clock, ArrowRight } from "lucide-react";

export default function TourCard({ tour, index = 0 }) {
  const { pick, t } = useLang();
  return (
    <Link
      to={`/tours/${tour.slug}`}
      data-testid={`tour-card-${tour.slug}`}
      className="group block hover-zoom"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="aspect-[4/5] w-full overflow-hidden bg-sand-200 relative">
        <img
          src={imgUrl(tour.hero_image)}
          alt={pick(tour.title_en, tour.title_fr)}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-4 left-4 bg-sand-50/95 backdrop-blur-sm text-charcoal text-xs uppercase tracking-widest px-3 py-1.5 rounded-full">
          <span className="text-terracotta mr-1">·</span>{tour.location}
        </div>
        <div className="absolute bottom-4 right-4 bg-charcoal/90 backdrop-blur-sm text-sand-50 px-4 py-2 rounded-full">
          <span className="text-[10px] uppercase tracking-widest text-sand-50/70 mr-1.5">{t.home.from}</span>
          <span className="font-serif-display text-lg">€{tour.price}</span>
        </div>
      </div>

      <div className="mt-5">
        <div className="flex items-center gap-3 text-xs text-charcoal-400 uppercase tracking-widest mb-2">
          <span className="inline-flex items-center gap-1"><Clock size={12} /> {tour.duration}</span>
          <span className="inline-flex items-center gap-1"><MapPin size={12} /> {tour.location}</span>
        </div>
        <h3 className="font-serif-display text-2xl md:text-3xl text-charcoal leading-[1.15] group-hover:text-terracotta transition-colors">
          {pick(tour.title_en, tour.title_fr)}
        </h3>
        <p className="mt-3 text-charcoal-400 text-sm md:text-base leading-relaxed line-clamp-2">
          {pick(tour.short_desc_en, tour.short_desc_fr)}
        </p>
        <span
          data-testid={`tour-card-cta-${tour.slug}`}
          className="mt-5 inline-flex items-center gap-2 text-charcoal group-hover:text-terracotta border-b border-charcoal group-hover:border-terracotta pb-1 text-sm tracking-wide transition-colors"
        >
          {t.card.view} <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
